(function () {
  var TABLE_SELECTOR = '[data-products-fifth-table]';

  function initTable(root) {
    var table = root.querySelector(TABLE_SELECTOR);
    if (!table || table.dataset.tableAnimated === 'true') return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      table.classList.add('is-animated');
      table.dataset.tableAnimated = 'true';
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          observer.disconnect();
          table.classList.add('is-animated');
          table.dataset.tableAnimated = 'true';
        });
      },
      { threshold: 0.3 }
    );

    observer.observe(table);
  }

  function boot(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-products-fifth]').forEach(initTable);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
